import React from 'react';
export function EliteSection() {
  return <section className="w-full bg-[#001a0d] py-16 px-4" data-id="element-74">
      <div className="max-w-4xl mx-auto" data-id="element-75">
        <div className="text-center mb-10" data-id="element-76">
          <h2 className="text-3xl sm:text-4xl font-black text-white mb-4" data-id="element-77">
            📋 ¿Qué agrega El Manual del DT Ganador?
          </h2>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto" data-id="element-78">
            Vos ya tenés el material para entrenar de lunes a viernes. El Manual
            del DT Ganador resuelve el sábado también.
          </p>
        </div>

        {/* Comparison Table */}
        <div className="bg-black border border-[#00C853]/30 rounded-2xl overflow-hidden mb-12" data-id="element-79">
          <div className="grid grid-cols-1 sm:grid-cols-3 bg-[#000d08] border-b border-[#00C853]/30" data-id="element-80">
            <div className="p-4 font-bold text-white hidden sm:block" data-id="element-81">
              Situación
            </div>
            <div className="p-4 font-bold text-gray-400 text-center border-l border-[#00C853]/30" data-id="element-82">
              Sin el Manual
            </div>
            <div className="p-4 font-bold text-[#00C853] text-center border-l border-[#00C853]/30" data-id="element-83">
              Con el Manual
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-84">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-85">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-86">
                Situación:
              </span>
              Van perdiendo 2-0 al entretiempo
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-87">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-88">
                Sin el Manual:
              </span>
              "Hay que meterle más ganas"
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-89">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-90">
                Con el Manual:
              </span>
              Rombo Ofensivo + cambio estratégico planificado
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-91">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-92">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-93">
                Situación:
              </span>
              No podés leer al rival
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-94">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-95">
                Sin el Manual:
              </span>
              Te das cuenta en el minuto 25
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-96">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-97">
                Con el Manual:
              </span>
              En 5 minutos tenés los datos clave y el antídoto
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-98">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-99">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-100">
                Situación:
              </span>
              El árbitro cobra un penal injusto
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-101">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-102">
                Sin el Manual:
              </span>
              Te calentás y perdés el eje
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-103">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-104">
                Con el Manual:
              </span>
              Protocolo de banco: el equipo no se desconcentra
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-105">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-106">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-107">
                Situación:
              </span>
              Necesitás cambiar el sistema
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-108">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-109">
                Sin el Manual:
              </span>
              Gritás instrucciones desde afuera
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-110">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-111">
                Con el Manual:
              </span>
              El capitán ejecuta la seña en 3 segundos
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-112">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-113">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-114">
                Situación:
              </span>
              Hay córner en tiempo de descuento
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-115">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-116">
                Sin el Manual:
              </span>
              Improvisás quién va al área
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-117">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-118">
                Con el Manual:
              </span>
              Ejecutan la variante ensayada el jueves
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 border-b border-gray-800" data-id="element-119">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-120">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-121">
                Situación:
              </span>
              El equipo ganando se pone nervioso
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-122">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-123">
                Sin el Manual:
              </span>
              "Tranquilos, tranquilos"
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-124">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-125">
                Con el Manual:
              </span>
              Cuadrado Defensivo activado + instrucción exacta
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3" data-id="element-126">
            <div className="p-4 text-white text-sm sm:text-base" data-id="element-127">
              <span className="sm:hidden font-bold text-gray-400 block mb-1" data-id="element-128">
                Situación:
              </span>
              Tenés que hablar en el entretiempo
            </div>
            <div className="p-4 text-gray-400 text-sm sm:text-base sm:border-l border-gray-800 bg-gray-900/30" data-id="element-129">
              <span className="sm:hidden font-bold text-gray-500 block mb-1" data-id="element-130">
                Sin el Manual:
              </span>
              Siempre el mismo discurso
            </div>
            <div className="p-4 text-white text-sm sm:text-base sm:border-l border-gray-800 bg-[#00C853]/5" data-id="element-131">
              <span className="sm:hidden font-bold text-[#00C853] block mb-1" data-id="element-132">
                Con el Manual:
              </span>
              El Discurso Táctico de 90 segundos exactos
            </div>
          </div>
        </div>

        {/* Features List */}
        <h3 className="text-2xl font-black text-white text-center mb-8" data-id="element-133">
          ✅ EL MANUAL DEL DT GANADOR INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-134">
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-135">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-136">
              El Ojo del DT — Scouting Express
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-137">
              Los 10 estilos de juego rival del Baby Fútbol argentino con su
              antídoto táctico. La planilla de scouting que completás en 5
              minutos antes del partido. Cómo leer al rival en los primeros 5
              minutos del partido.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-138">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-139">
              El Tablero de Comando — Ajustes en Tiempo Real
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-140">
              Sistema completo de decisiones predefinidas para cada situación de
              marcador. Los 5 tipos de cambio estratégico con el Protocolo del
              Cambio Perfecto. El Protocolo del Entretiempo de 5 minutos
              exactos.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-141">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-142">
              El Arsenal Invisible — 20 Jugadas de Pizarrón
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-143">
              7 variantes de córner con diagramas completos. 5 variantes de
              lateral. 5 variantes de tiro libre. 3 variantes de saque de
              inicio. Todo con diagramas de campo y script listo para
              comunicárselo al equipo.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5" data-id="element-144">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-145">
              El Idioma de la Victoria — Psicología de Banco
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-146">
              Los 5 tipos de discurso (Motivador, Táctico, Correctivo, De Calma,
              Post-Derrota) con ejemplos listos para usar. Las 10 frases que un
              DT nunca debería decir y su alternativa. Las 5 situaciones más
              difíciles del banco y cómo manejarlas.
            </p>
          </div>
          <div className="bg-black border border-[#00C853]/20 rounded-xl p-5 md:col-span-2" data-id="element-147">
            <h4 className="text-[#00C853] font-bold text-lg mb-2" data-id="element-148">
              Recursos Printables
            </h4>
            <p className="text-gray-400 text-sm" data-id="element-149">
              Planilla de Preparación Pre-Partido. Planilla de Análisis
              Post-Partido. Tarjeta de Banco plastificable para llevar al
              sábado. Checklist del DT Estratega.
            </p>
          </div>
        </div>
      </div>
    </section>;
}